import { useEffect, useState } from "react";

// Hook to fetch tickets from a fully-formed endpoint using an optional JWT token
// Params: { endpoint: string, token?: string }
// Added optional refreshKey param so callers can force a refetch (manual button / interval)
export function useProjectTickets({ endpoint, token, refreshKey = 0 }) {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    // If there's no endpoint, nothing to do
    if (!endpoint) return;
    // Require a valid token before fetching to avoid duplicate unauthenticated calls
    if (!token) return;

  setLoading(true);
  setError("");
    const doFetch = async () => {
      try {
        const res = await fetch(endpoint, {
          headers: {
            Accept: "application/json",
            Authorization: `${token}`,
          },
        });
        if (!res.ok) {
          // Keep errors user-friendly; avoid dumping raw server text
          throw new Error("Unable to fetch tickets. Please try again.");
        }
        const data = await res.json();
        if (!Array.isArray(data)) throw new Error("Unexpected response from server.");
        if (!alive) return;
        setTickets(data);
      } catch (e) {
        if (!alive) return;
        setError(e?.message || String(e));
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    };

    doFetch();
    return () => {
      alive = false;
    };
  }, [endpoint, token, refreshKey]);

  return { tickets, loading, error, endpoint };
}
